import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'] // , '../../assets/scss/stylesMat.scss', '../../assets/scss/toastr.css']
})
export class UserComponent implements OnInit {

  constructor() {
    // console.log('en el constructor de user login');
   }

  ngOnInit() {
    // console.log('en el init de user login');
  }

}



// WEBPACK FOOTER //
// ./src/app/user/user.component.ts